import StepCard from "../../components/Steps/StepCard";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

const stepsContent = [
    {
        id: "step-1",
        illustration: "assets/illustrations/step-1.svg",
        stepNumber: 1,
        titlePT: "Escolha a app",
        titleEN: "Choose the app",
        paragraphPT: "Escolha a app sobre a qual gostaria de obter um voucher.",
        paragraphEN:"Choose the app you would like to get a voucher for."
    },
    {
        id: "step-2",
        illustration: "assets/illustrations/step-2.svg",
        stepNumber: 2,
        titlePT: "Escolha o valor",
        titleEN: "Choose the amount",
        paragraphPT: "Escolha o valor do voucher que deseja obter.",
        paragraphEN: "Choose the voucher amount you want to get "
    },
    {
        id: "step-3",
        illustration: "assets/illustrations/step-3.svg",
        stepNumber: 3,
        titlePT: "Insira o seu número",
        titleEN: "Enter your number",
        paragraphPT:
            "Para concluir a compra, insira o número de telemóvel da sua conta My Ticket® e aceite o pagamento.",
        paragraphEN: "To complete the purchase, enter your My Ticket® account mobile number and accept payment. "
    },
    {
        id: "step-4",
        illustration: "assets/illustrations/step-4.svg",
        stepNumber: 4,
        titlePT: "Utilize o voucher",
        titleEN: "Use the voucher",
        paragraphPT:
            "Clique no link ou utilize o código gerado na app que escolheu. O valor do voucher já está disponível!",
        paragraphEN: "Click on the link or use the code generated in the app you chose. The amount is now available! "
    }
];

const HowItWorks = () => {
    const { t } = useTranslation();
    const currentLanguage = i18n.language.slice(0, 2);

    return (
        <section id="how-it-works" className="container mt-7">
            <h1>{t("home.howItWorks")}</h1>
            <p>{t("home.stepsTitle")}</p>
            {stepsContent.map(step => (
                <StepCard
                    key={step.id}
                    illustration={step.illustration}
                    stepNumber={step.stepNumber}
                    title={currentLanguage === "pt" ? step.titlePT : step.titleEN}
                    paragraph={currentLanguage === "pt" ? step.paragraphPT : step.paragraphEN}
                />
            ))}
            <a href="#buy-voucher" className="secondary-button goToTop">
                {t("home.buyVoucher")}
                <img
                    alt=""
                    className="ml-3"
                    src="assets/icons/arrow-top-primary-color.svg"
                />
            </a>
        </section>
    );
};

export default HowItWorks;
